export * from './categories.service';
import { CategoriesService } from './categories.service';
export * from './children.service';
import { ChildrenService } from './children.service';
export * from './contracts.service';
import { ContractsService } from './contracts.service';
export * from './currentPapCategories.service';
import { CurrentPapCategoriesService } from './currentPapCategories.service';
export * from './eduActivities.service';
import { EduActivitiesService } from './eduActivities.service';
export * from './lastResults.service';
import { LastResultsService } from './lastResults.service';
export * from './materials.service';
import { MaterialsService } from './materials.service';
export * from './papCategories.service';
import { PapCategoriesService } from './papCategories.service';
export * from './registration.service';
import { RegistrationService } from './registration.service';
export * from './teacherActivity.service';
import { TeacherActivityService } from './teacherActivity.service';
export * from './teacherActivityTargetLink.service';
import { TeacherActivityTargetLinkService } from './teacherActivityTargetLink.service';
export * from './teacherAdditionalInfo.service';
import { TeacherAdditionalInfoService } from './teacherAdditionalInfo.service';
export * from './teacherFiles.service';
import { TeacherFilesService } from './teacherFiles.service';
export * from './teacherResults.service';
import { TeacherResultsService } from './teacherResults.service';
export * from './teacherTarget.service';
import { TeacherTargetService } from './teacherTarget.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [CategoriesService, ChildrenService, ContractsService, CurrentPapCategoriesService, EduActivitiesService, LastResultsService, MaterialsService, PapCategoriesService, RegistrationService, TeacherActivityService, TeacherActivityTargetLinkService, TeacherAdditionalInfoService, TeacherFilesService, TeacherResultsService, TeacherTargetService, UsersService];
